import { Routing } from "helpers/routing";
import React, { createContext } from "react";
const MatchDatasourceIdentifierContext = createContext<{
  params?: Routing.MatchDatasourceIdentifierParams
}>({})

export default MatchDatasourceIdentifierContext
